import * as React from "react";
import { isNil } from "ramda";

interface Props {
  values: string[],
  links?: string[],
  fallbackValues?: string[]
  joinCharacter?: string
  hideLeadingZeros?: boolean
  showVertical?: boolean
  color?: boolean
}

export function ItemTableCellComponent(props: Props) {

  const {
    values,
    links,
    fallbackValues,
    joinCharacter,
    hideLeadingZeros,
    showVertical
  } = props

  let texts = values
    .filter(x => !isNil(x) && x.length > 0)
    .map(x => hideLeadingZeros ? x.replace(/^0+/, '') : x)

  if (texts.length === 0 && (fallbackValues || []).length !== 0) {
    texts = fallbackValues
      .filter(x => !isNil(x) && x.length > 0)
  }

  if (showVertical) {
    return (
      <>
        {texts.map((text, index) => (
          links?.[index] ? (
            <div key={index}>
              <a
                key={index}
                href={links[index]}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{
                  color: props.color ? "red" : undefined,
                  marginRight: "4px",
                  textDecoration: "underline"
                }}
              >
                {text}
              </a>
            </div>
          ) : (
            <div
              key={index}
              style={{ color: props.color ? "red" : undefined }}
            >
              {text}
            </div>
          )
        ))}
      </>
    )
  }

  return (
    <>
      {texts.map((text, index) => (
        links?.[index] ? (
          <a
            key={index}
            href={links[index]}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: props.color ? "red" : undefined,
              marginRight: "4px",
              textDecoration: "underline"
            }}
          >
            {text}
          </a>
        ) : (
          <span
            key={index}
            style={{
              color: props.color ? "red" : undefined,
              marginRight: "4px"
            }}
          >
            {text}
          </span>
        )
      ))}
    </>
  );
}